import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { createGtm } from '@gtm-support/vue-gtm';
import './scss/main.scss';
import Price from './components/elements/Price';
import AppTabs from './components/elements/Tabs';
import PageBreadCrumbs from './components/elements/PageBreadCrumbs';
import mq from './plugins/mq';
import { bgImageDirective } from './directives/bgImageDirective';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(mq);
app.use(
  createGtm({
    id: `${process.env.VUE_APP_MARVIN_GTM}`,
    debug: JSON.parse(process.env.VUE_APP_MARVIN_GTM_DEBUG || 'false'),
    enabled: store.getters['cookies/isGoogleAnalyticsCookies'],
    vueRouter: router
  })
);

app.component('price', Price);
app.component('app-tabs', AppTabs);
app.component('page-bread-crumbs', PageBreadCrumbs);

app.directive('bg-image', bgImageDirective);

app.mount('#app');
